import { DriverState, DriverAction } from "./types";

export const initialState: DriverState = {
  personalInfo: {
    name: "",
    email: "",
    education: "",
    phoneNumber: "",
    dateOfBirth: "",
    address: "",
    aadharNumber: "",
    username: "",
    password: "",
    deliveryBoy: "",
    samplePickUpPerson: "",
    driverType: "driver",
  },
  vehicleInfo: {
    vehicleBrand: "",
    vehicleModel: "",
    vehicleNumber: "",
    driverLicenseNumber: "",
  },
  currentStep: "personal",
};

export const driverReducer = (
  state: DriverState,
  action: DriverAction
): DriverState => {
  switch (action.type) {
    case "UPDATE_PERSONAL_INFO":
      return {
        ...state,
        personalInfo: { ...state.personalInfo, ...action.payload },
      };
    case "UPDATE_VEHICLE_INFO":
      return {
        ...state,
        vehicleInfo: { ...state.vehicleInfo, ...action.payload },
      };
    case "SET_STEP":
      return {
        ...state,
        currentStep: action.payload,
      };
    case "RESET":
      return initialState;
    case "CLOSE_FORM":
      return {
        ...initialState,
        currentStep: "", 
      };
    default:
      return state;
  }
};
